import $ from 'jquery'
import trailingSlashIt from 'trailing-slash-it'
import { blockDiv, unBlockDiv } from '../functions'

// eslint-disable-next-line no-undef
const object = casanovaObject

$('.seedlings-filter-item__title').on('click', function () {
  const $this = $(this)
  const wrapper = $this.parent()
  const content = wrapper.find('.seedlings-filter-item__content')

  wrapper.toggleClass('seedlings-filter-item--collapsed')
  content.slideToggle(250)
})

const request = () => {
  const wrapper = $('.seedlings-filter')
  const url = wrapper.attr('data-url')
  const allInputs = $('.seedlings-filter input[type=checkbox]')
  const posts = $('.seedlings-posts > .row')
  const search = wrapper.find('.casanova-search input')

  let seedlingTypes = []
  let seedlingFamilies = []
  let productFamilies = []
  let ranges = []
  let s = search.val()

  allInputs.each(function () {
    const cur = $(this)
    const name = cur.attr('name')
    const val = cur.val()

    if (cur.is(':checked')) {
      if (name === 'seedling-type') {
        seedlingTypes.push(val)
      }

      if (name === 'seedling-family') {
        seedlingFamilies.push(val)
      }

      if (name === 'product-family') {
        productFamilies.push(val)
      }

      if (name === 'range') {
        ranges.push(val)
      }
    }
  })

  const stringArr = []

  if (seedlingTypes.length) {
    stringArr.push(`types-plant/${seedlingTypes.join(',')}`)
  }

  if (seedlingFamilies.length) {
    stringArr.push(`familles-plant/${seedlingFamilies.join(',')}`)
  }

  if (productFamilies.length) {
    stringArr.push(`familles-produit/${productFamilies.join(',')}`)
  }

  if (ranges.length) {
    stringArr.push(`gammes/${ranges.join(',')}`)
  }

  let string = stringArr.join('/')
  const uri = trailingSlashIt(url + string)
  history.pushState({}, null, uri)

  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    dataType: 'JSON',
    data: {
      _ajax_nonce: object.nonce,
      action: 'casanova_filter_seedlings',
      seedlingTypes,
      seedlingFamilies,
      productFamilies,
      ranges,
      s,
    },
    beforeSend: () => {
      blockDiv(wrapper)
    },
    success: (res) => {
      posts.html(res.data.content)

      if (res.success) {
        history.pushState({}, null, uri)
      }
    },
    complete: () => {
      const pag = $('.casanova-pagination')

      if (pag.length) {
        $('.casanova-pagination').load(
          location.href + ' .casanova-pagination > *',
          function () {
            unBlockDiv(wrapper)
          }
        )
      } else {
        unBlockDiv(wrapper)
      }
    },
  })
}

$('.seedlings-filter input[type=checkbox]').on('change', request)

$('.seedlings-filter__show').on('click', function () {
  $('body').removeClass('filter-active')

  document
    .querySelector('.seedlings-posts')
    .scrollIntoView({ behavior: 'smooth' })
})
